// extracted by mini-css-extract-plugin
export default {"paragraphContainer":"styles_paragraphContainer__EWCAD"};